import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const IS_ACTIVE = 'is_active'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [IS_ACTIVE]: {
      label: `${t('common.active')}`,
      name: IS_ACTIVE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [IS_ACTIVE]: false,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
  })

export default formModel
